export default "__VITE_ASSET__FFnJ7CW3__"